import { ReactNode } from "react";
import Flex from "@/components/Flex";
import Input from "@/components/Input";
import { HistoryRow } from "../readmission-f2f-types";
import { useSectionRequirement } from "../section-requirement-context";
import {
  HISTORY_FIELD_FLEX,
  HISTORY_NOTES_LABEL,
  HISTORY_NOTES_PLACEHOLDER,
} from "../readmission-f2f-constant";

export interface HistoryEntryRowProps {
  row: HistoryRow;
  nameLabel: string;
  namePlaceholder: string;
  disabled?: boolean;
  /** Inline message under the name field. */
  error?: string;
  /** The new-entry row: its fields are validated by the add action, not by Save & Sign. */
  isDraft?: boolean;
  action: ReactNode;
  onChange: (patch: Partial<HistoryRow>) => void;
  onCommit?: (row: HistoryRow) => void;
}

const HistoryEntryRow = ({
  row,
  nameLabel,
  namePlaceholder,
  disabled = false,
  error,
  isDraft = false,
  action,
  onChange,
  onCommit,
}: HistoryEntryRowProps) => {
  const { isRequired, missingError } = useSectionRequirement();
  return (
    <Flex gap={2} alignItems="flex-start" flexWrap="wrap">
      <Input
        label={nameLabel}
        required={isRequired}
        error={error ?? (isDraft ? undefined : missingError(row.name))}
        flexprops={HISTORY_FIELD_FLEX}
        textFieldProps={{
          fullWidth: true,
          placeholder: namePlaceholder,
          value: row.name,
          disabled,
          onChange: (e) => onChange({ name: e.target.value }),
          onBlur: () => onCommit?.(row),
        }}
      />
      <Input
        label={HISTORY_NOTES_LABEL}
        flexprops={HISTORY_FIELD_FLEX}
        textFieldProps={{
          fullWidth: true,
          placeholder: HISTORY_NOTES_PLACEHOLDER,
          value: row.notes,
          disabled,
          onChange: (e) => onChange({ notes: e.target.value }),
          onBlur: () => onCommit?.(row),
        }}
      />
      {action}
    </Flex>
  );
};

export default HistoryEntryRow;
